// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info {
  max-width: 70%;
  vertical-align: top;
  display: block; }
  .user-info .user-fullname {
    font-size: 16px;
    color: black; }
  .user-info.ellipsis > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;
    display: block; }

.user-title, .user-org {
  color: #909092;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.user-gb, .user-moderator {
  color: #f2b130;
  font-size: 12px; }

.attendees {
  margin-top: 1em; }
  .attendees hr {
    margin-top: 0;
    margin-bottom: 0; }
  .attendees .user-list {
    padding: 5px;
    display: block;
    position: relative; }
    .attendees .user-list .user-icons {
      margin: .5em;
      position: absolute;
      top: 0;
      right: 0;
      color: #606060; }
      .attendees .user-list .user-icons ul li {
        list-style-type: none; }

.biz-card-div {
  cursor: pointer;
  margin-top: 2px;
  padding: 5px;
  text-align: center;
  background-color: #4330ff;
  border: 1px solid #4330ff;
  color: white;
  width: 100%; }

.biz-card-link:hover {
  color: white;
  cursor: pointer; }
  .biz-card-link:hover:hover {
    text-decoration: none;
    color: white; }

.user-filter-div {
  margin-top: 0px;
  background-color: #002856; }

/*user-list*/
.user-list-link {
  color: black; }

.user-list-link:hover {
  color: black;
  background: #f2f2f2; }

.user-list.hover:hover {
  background: #f2f2f2; }

.nohover {
  cursor: default; }

.user-list .user-info {
  display: inline-block;
  width: 85%;
  padding: 5px 0 0 10px; }

/*user-page*/
.user-profile .user-list-link:hover {
  background: none; }

.user-profile .user-list:hover {
  background: none; }

.user-profile .user-list {
  margin-top: 1em; }
  .user-profile .user-list .user-icons {
    margin: .5em;
    float: right; }
    .user-profile .user-list .user-icons ul li {
      list-style-type: none; }
  .user-profile .user-list:hover {
    cursor: default; }

.user-profile .blue-header {
  color: #4330ff; }

.user-profile .user-actions {
  padding: 1em 0 1em 0; }
  .user-profile .user-actions .disabled-send {
    color: #909092; }
  .user-profile .user-actions button {
    width: 100%;
    border-radius: 5px;
    background-color: #f2f2f2;
    border: 1px solid #c0c0c0;
    color: #4330ff;
    margin-bottom: 0.5em; }
  .user-profile .user-actions .active-button {
    background-color: #4330ff;
    color: white; }

.user-profile .user-bio .no-bio {
  color: #909092; }

.user-profile .red a button {
  color: #ff2e2e; }

.fa-stack {
  width: 100%;
  height: 100%;
  line-height: 1.5;
  font-size: 1rem; }

.fa-stack[data-count]:after {
  position: absolute;
  right: -1%;
  top: 1%;
  content: attr(data-count);
  font-size: 30%;
  padding: .6em;
  border-radius: 999px;
  line-height: .75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold; }

/*my-profile*/
.my-biz-card {
  background: #dcdcdc;
  border: .15em solid #000;
  border-radius: .75em;
  padding: .75em; }

.form-fine-print {
  color: #909092; }

.display-date {
  background: gray;
  color: #fff;
  padding: .2em .45em; }

.session-link {
  width: calc(100% - 100px); }
  .session-link:hover {
    text-decoration: none; }

.session-icons {
  margin: .5em;
  position: absolute;
  right: 0;
  top: 0;
  color: #606060; }
  .session-icons ul li {
    list-style-type: none; }

.user-profile .button-disabled {
  color: gray !important; }

.user-profile .session {
  color: black;
  border: 0.5px solid #eaeaea;
  line-height: 10px;
  text-decoration: none;
  position: relative; }

.user-profile .session:hover {
  background: #d4e4e9; }

.user-profile .session-time {
  background: #909092;
  color: white;
  padding: 10px; }

.user-profile .session-reg {
  text-align: center;
  width: 90px; }
  .user-profile .session-reg .fa {
    margin-top: .1em;
    font-size: 2.25em; }
    .user-profile .session-reg .fa.fa-plus-circle {
      color: gray; }
    .user-profile .session-reg .fa.fa-check-circle {
      color: #4330ff; }
      .user-profile .session-reg .fa.fa-check-circle.yellow {
        color: #feb52b; }

.user-profile .session-name {
  padding-top: 10px;
  color: black;
  line-height: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  display: block; }

.user-profile .session-room {
  padding-top: 0px;
  color: #909092;
  font-size: 12px; }

.user-profile .track-color {
  display: inline;
  padding: 1px;
  float: left;
  width: .25em;
  min-height: 4.5em;
  margin-right: .35em; }

.user-profile .session-reg {
  border: 0.5px solid #eaeaea;
  background: #f2f2f2;
  padding-right: 0px !important; }
  .user-profile .session-reg p {
    margin: 5px 0 5px -5px;
    text-align: center; }

.blue {
  color: #4330ff; }

.session-name {
  padding-top: 10px;
  color: black; }

.session-room {
  padding-top: 0px;
  color: #909092;
  font-size: 12px; }

.session.itinerary {
  padding: 20px; }
  .session.itinerary .session-name {
    color: #909092; }

@media only screen and (max-width: 760px) {
  .session-reg {
    width: 60px;
    font-size: 12px; } }

.my-profile-photo {
  margin-top: 30px;
  text-align: center; }
  .my-profile-photo button {
    border-radius: 5px;
    background-color: #f2f2f2;
    border: 1px solid #c0c0c0;
    color: #4330ff;
    margin-bottom: 3px;
    margin-left: 5px; }
  .my-profile-photo input[type="file"] {
    display: none; }
  .my-profile-photo .custom-file-upload {
    border-radius: 5px;
    background-color: #f2f2f2;
    border: 1px solid #c0c0c0;
    color: #4330ff;
    display: inline-block;
    padding: 6px 12px;
    margin-left: 5px;
    cursor: pointer; }
  .my-profile-photo .rounded-circle {
    max-width: 250px; }

.business-card-info {
  background-color: #f2f2f2;
  border: 1px solid #404040;
  color: #404040;
  border-radius: 5px;
  padding: 10px; }
  .business-card-info .name {
    font-size: 1.5em;
    font-weight: bold; }
`, "",{"version":3,"sources":["webpack://./src/components/Users/users.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc,EAAE;EAChB;IACE,eAAe;IACf,YAAY,EAAE;EAChB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iDAAiD;IACjD,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,sEAAsE;IACtE,qBAAqB;IACrB,uCAAuC;IACvC,sBAAsB;IACtB,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;EACjB;IACE,aAAa;IACb,gBAAgB,EAAE;EACpB;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAE;IACpB;MACE,YAAY;MACZ,kBAAkB;MAClB,MAAM;MACN,QAAQ;MACR,cAAc,EAAE;MAChB;QACE,qBAAqB,EAAE;;AAE/B;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,YAAY;EACZ,eAAe,EAAE;EACjB;IACE,qBAAqB;IACrB,YAAY,EAAE;;AAElB;EACE,eAAe;EACf,yBAAyB,EAAE;;AAE7B,YAAY;AACZ;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY;EACZ,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,eAAe,EAAE;;AAEnB;EACE,qBAAqB;EACrB,UAAU;EACV,qBAAqB,EAAE;;AAEzB,YAAY;AACZ;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,eAAe,EAAE;EACjB;IACE,YAAY;IACZ,YAAY,EAAE;IACd;MACE,qBAAqB,EAAE;EAC3B;IACE,eAAe,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,oBAAoB,EAAE;EACtB;IACE,cAAc,EAAE;EAClB;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oBAAoB,EAAE;EACxB;IACE,yBAAyB;IACzB,YAAY,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAE;;AAErB,aAAa;AACb;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB,EAAE;;AAEvB;EACE,yBAAyB,EAAE;EAC3B;IACE,qBAAqB,EAAE;;AAE3B;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,cAAc,EAAE;EAChB;IACE,qBAAqB,EAAE;;AAE3B;EACE,sBAAsB,EAAE;;AAE1B;EACE,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,WAAW,EAAE;EACb;IACE,gBAAgB;IAChB,iBAAiB,EAAE;IACnB;MACE,WAAW,EAAE;IACf;MACE,cAAc,EAAE;MAChB;QACE,cAAc,EAAE;;AAExB;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iDAAiD;EACjD,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sEAAsE;EACtE,qBAAqB;EACrB,uCAAuC;EACvC,sBAAsB;EACtB,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B,EAAE;EAC/B;IACE,sBAAsB;IACtB,kBAAkB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB;EACjB,YAAY,EAAE;;AAEhB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;EACf;IACE,cAAc,EAAE;;AAEpB;EACE;IACE,WAAW;IACX,eAAe,EAAE,EAAE;;AAEvB;EACE,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,gBAAgB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa,EAAE;EACf;IACE,gBAAgB;IAChB,iBAAiB,EAAE","sourcesContent":[".user-info {\n  max-width: 70%;\n  vertical-align: top;\n  display: block; }\n  .user-info .user-fullname {\n    font-size: 16px;\n    color: black; }\n  .user-info.ellipsis > div {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* These are technically the same, but use both */\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    /* This is the dangerous one in WebKit, as it breaks things wherever */\n    word-break: break-all;\n    /* Instead use this non-standard one: */\n    word-break: break-word;\n    display: block; }\n\n.user-title, .user-org {\n  color: #909092;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.user-gb, .user-moderator {\n  color: #f2b130;\n  font-size: 12px; }\n\n.attendees {\n  margin-top: 1em; }\n  .attendees hr {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .attendees .user-list {\n    padding: 5px;\n    display: block;\n    position: relative; }\n    .attendees .user-list .user-icons {\n      margin: .5em;\n      position: absolute;\n      top: 0;\n      right: 0;\n      color: #606060; }\n      .attendees .user-list .user-icons ul li {\n        list-style-type: none; }\n\n.biz-card-div {\n  cursor: pointer;\n  margin-top: 2px;\n  padding: 5px;\n  text-align: center;\n  background-color: #4330ff;\n  border: 1px solid #4330ff;\n  color: white;\n  width: 100%; }\n\n.biz-card-link:hover {\n  color: white;\n  cursor: pointer; }\n  .biz-card-link:hover:hover {\n    text-decoration: none;\n    color: white; }\n\n.user-filter-div {\n  margin-top: 0px;\n  background-color: #002856; }\n\n/*user-list*/\n.user-list-link {\n  color: black; }\n\n.user-list-link:hover {\n  color: black;\n  background: #f2f2f2; }\n\n.user-list.hover:hover {\n  background: #f2f2f2; }\n\n.nohover {\n  cursor: default; }\n\n.user-list .user-info {\n  display: inline-block;\n  width: 85%;\n  padding: 5px 0 0 10px; }\n\n/*user-page*/\n.user-profile .user-list-link:hover {\n  background: none; }\n\n.user-profile .user-list:hover {\n  background: none; }\n\n.user-profile .user-list {\n  margin-top: 1em; }\n  .user-profile .user-list .user-icons {\n    margin: .5em;\n    float: right; }\n    .user-profile .user-list .user-icons ul li {\n      list-style-type: none; }\n  .user-profile .user-list:hover {\n    cursor: default; }\n\n.user-profile .blue-header {\n  color: #4330ff; }\n\n.user-profile .user-actions {\n  padding: 1em 0 1em 0; }\n  .user-profile .user-actions .disabled-send {\n    color: #909092; }\n  .user-profile .user-actions button {\n    width: 100%;\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    color: #4330ff;\n    margin-bottom: 0.5em; }\n  .user-profile .user-actions .active-button {\n    background-color: #4330ff;\n    color: white; }\n\n.user-profile .user-bio .no-bio {\n  color: #909092; }\n\n.user-profile .red a button {\n  color: #ff2e2e; }\n\n.fa-stack {\n  width: 100%;\n  height: 100%;\n  line-height: 1.5;\n  font-size: 1rem; }\n\n.fa-stack[data-count]:after {\n  position: absolute;\n  right: -1%;\n  top: 1%;\n  content: attr(data-count);\n  font-size: 30%;\n  padding: .6em;\n  border-radius: 999px;\n  line-height: .75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold; }\n\n/*my-profile*/\n.my-biz-card {\n  background: #dcdcdc;\n  border: .15em solid #000;\n  border-radius: .75em;\n  padding: .75em; }\n\n.form-fine-print {\n  color: #909092; }\n\n.display-date {\n  background: gray;\n  color: #fff;\n  padding: .2em .45em; }\n\n.session-link {\n  width: calc(100% - 100px); }\n  .session-link:hover {\n    text-decoration: none; }\n\n.session-icons {\n  margin: .5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: #606060; }\n  .session-icons ul li {\n    list-style-type: none; }\n\n.user-profile .button-disabled {\n  color: gray !important; }\n\n.user-profile .session {\n  color: black;\n  border: 0.5px solid #eaeaea;\n  line-height: 10px;\n  text-decoration: none;\n  position: relative; }\n\n.user-profile .session:hover {\n  background: #d4e4e9; }\n\n.user-profile .session-time {\n  background: #909092;\n  color: white;\n  padding: 10px; }\n\n.user-profile .session-reg {\n  text-align: center;\n  width: 90px; }\n  .user-profile .session-reg .fa {\n    margin-top: .1em;\n    font-size: 2.25em; }\n    .user-profile .session-reg .fa.fa-plus-circle {\n      color: gray; }\n    .user-profile .session-reg .fa.fa-check-circle {\n      color: #4330ff; }\n      .user-profile .session-reg .fa.fa-check-circle.yellow {\n        color: #feb52b; }\n\n.user-profile .session-name {\n  padding-top: 10px;\n  color: black;\n  line-height: 1em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block; }\n\n.user-profile .session-room {\n  padding-top: 0px;\n  color: #909092;\n  font-size: 12px; }\n\n.user-profile .track-color {\n  display: inline;\n  padding: 1px;\n  float: left;\n  width: .25em;\n  min-height: 4.5em;\n  margin-right: .35em; }\n\n.user-profile .session-reg {\n  border: 0.5px solid #eaeaea;\n  background: #f2f2f2;\n  padding-right: 0px !important; }\n  .user-profile .session-reg p {\n    margin: 5px 0 5px -5px;\n    text-align: center; }\n\n.blue {\n  color: #4330ff; }\n\n.session-name {\n  padding-top: 10px;\n  color: black; }\n\n.session-room {\n  padding-top: 0px;\n  color: #909092;\n  font-size: 12px; }\n\n.session.itinerary {\n  padding: 20px; }\n  .session.itinerary .session-name {\n    color: #909092; }\n\n@media only screen and (max-width: 760px) {\n  .session-reg {\n    width: 60px;\n    font-size: 12px; } }\n\n.my-profile-photo {\n  margin-top: 30px;\n  text-align: center; }\n  .my-profile-photo button {\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    color: #4330ff;\n    margin-bottom: 3px;\n    margin-left: 5px; }\n  .my-profile-photo input[type=\"file\"] {\n    display: none; }\n  .my-profile-photo .custom-file-upload {\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    color: #4330ff;\n    display: inline-block;\n    padding: 6px 12px;\n    margin-left: 5px;\n    cursor: pointer; }\n  .my-profile-photo .rounded-circle {\n    max-width: 250px; }\n\n.business-card-info {\n  background-color: #f2f2f2;\n  border: 1px solid #404040;\n  color: #404040;\n  border-radius: 5px;\n  padding: 10px; }\n  .business-card-info .name {\n    font-size: 1.5em;\n    font-weight: bold; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
